var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TagSelector',{attrs:{"multiple":_vm.multiple,"items":_vm.list,"value":_vm.value,"itemText":"title","itemValue":"id"},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }